<template>
  <div>
    <v-row class="px-6 mb-4">
      <v-col cols="3">
        <v-text-field
          v-model="searchInputValue"
          prepend-inner-icon="$magnify"
          outlined
          dense
          single-line
          hide-details="auto"
          :placeholder="$t('spedilink.persons.searchPlaceholder')"
          clearable
        />
      </v-col>
    </v-row>

    <v-data-table
      :items="persons"
      :loading="loading"
      :headers="headers"
      hide-default-footer
      :page="dataTableOptions.page"
      :items-per-page="dataTableOptions.itemsPerPage"
      @update:options="updateOptions"
    >
      <template v-slot:[`item.addedBy`]="{ item }">
        <span v-if="item.addedByFirstName || item.addedByLastName">
          {{ item.addedByFirstName }} {{ item.addedByLastName }}
        </span>
        <span v-else>—</span>
        <div class="text-caption grey--text">
          {{ item.createdAt | dateFormat }}
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item link @click="openEditDialog(item)">
              <v-list-item-title>{{ $t('spedilink.persons.edit') }}</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="openDeleteDialog(item)">
              <v-list-item-title class="error--text">{{ $t('spedilink.persons.delete') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-slot:footer v-if="pageCount > 1">
        <v-pagination v-model="dataTableOptions.page" :length="pageCount" />
      </template>
    </v-data-table>

    <EditPublicSpediLinkPersonDialog
      v-model="editDialog"
      :person="selectedPerson"
      @close="editDialog = false"
      @person-edited="onPersonEdited()"
    />

    <DeletePublicSpediLinkPersonDialog
      v-model="deleteDialog"
      :person="selectedPerson"
      @close="deleteDialog = false"
      @person-deleted="onPersonDeleted()"
    />
  </div>
</template>

<script>
import Service from '@/services'
import EditPublicSpediLinkPersonDialog from '@/views/Companies/CustomerService/PublicSpedilink/EditPublicSpediLinkPersonDialog'
import DeletePublicSpediLinkPersonDialog from '@/views/Companies/CustomerService/PublicSpedilink/DeletePublicSpediLinkPersonDialog'

export default {
  name: 'PublicSpedilinkPersonsTable',
  components: {
    EditPublicSpediLinkPersonDialog,
    DeletePublicSpediLinkPersonDialog
  },
  data () {
    return {
      persons: [],
      loading: false,
      pageCount: 1,
      searchInputValue: '',
      searchTimeout: null,
      dataTableOptions: {
        page: 1,
        itemsPerPage: 15
      },
      sortProperties: [],
      selectedPerson: {},
      editDialog: false,
      deleteDialog: false,
      headers: [
        { text: this.$t('spedilink.persons.firstName'), value: 'firstName' },
        { text: this.$t('spedilink.persons.lastName'), value: 'lastName' },
        { text: this.$t('spedilink.persons.email'), value: 'email' },
        { text: this.$t('spedilink.persons.phone'), value: 'phone' },
        { text: this.$t('publicSpedilink.persons.addedBy'), value: 'addedBy', sortable: false },
        { text: '', align: 'end', width: '50', value: 'actions', sortable: false }
      ]
    }
  },
  async created () {
    await this.loadPersons()
  },
  watch: {
    searchInputValue () {
      this.dataTableOptions.page = 1
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.loadPersons()
      }, 500)
    },
    'dataTableOptions.page' () {
      this.loadPersons()
    }
  },
  methods: {
    async loadPersons () {
      this.loading = true
      try {
        const params = {
          page: this.dataTableOptions.page,
          pageSize: this.dataTableOptions.itemsPerPage
        }
        if (this.searchInputValue) params.search = this.searchInputValue
        if (this.sortProperties.length > 0) {
          params.sortableProperties = JSON.stringify(this.sortProperties)
        }
        const { data } = await Service.get('spedilink/PublicSpediLinkUsers/GetList', params)
        this.persons = data.results
        this.pageCount = Math.ceil(data.count / this.dataTableOptions.itemsPerPage)
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    updateOptions (options) {
      this.sortProperties = options.sortBy.map((element, index) => ({
        propertyName: element,
        priority: index,
        type: options.sortDesc[index] ? 1 : 0
      }))
      this.loadPersons()
    },
    openEditDialog (person) {
      this.selectedPerson = person
      this.editDialog = true
    },
    openDeleteDialog (person) {
      this.selectedPerson = person
      this.deleteDialog = true
    },
    async onPersonEdited () {
      this.editDialog = false
      await this.loadPersons()
    },
    async onPersonDeleted () {
      this.deleteDialog = false
      if (this.persons.length === 1 && this.dataTableOptions.page > 1) {
        this.dataTableOptions.page -= 1
      } else {
        await this.loadPersons()
      }
    }
  }
}
</script>
